import { Container } from "@sainsburys-tech/luna-grid"
import { Display3, Body1 } from "@sainsburys-tech/luna-typography"
import Drafts from "../components/Drafts/Drafts"
import { useEffect } from "react"

const DraftsPage = () => {

  useEffect(() => {
    if (sessionStorage.getItem('investigationId')) {
      sessionStorage.removeItem('investigationId')
    }
    if (sessionStorage.getItem('enforcementContact') == 'true') {
      sessionStorage.setItem('enforcementContact', 'false')
    }
  }, [])

  return (
    <div className="s-drafts-dashboard ln-u-1/1 ln-u-padding*3">
      <Container className="ln-u-padding-bottom*4" size="xs">
        <div>
          <Display3 id="s-page-title" className="s-page-title ln-u-padding-left*2">
            My drafts
          </Display3>
        </div>
        <div>
          <Body1 id="s-page-label" className="s-page-label s-page-label-display ln-u-padding-left*2">
            Drafts are kept for 7 days, so that reports are accurate and we don&apos;t keep information longer than we need to.
          </Body1>
        </div>
      </Container>

      <Container className="s-drafts" size="xs">
        <Drafts />
      </Container>
    </div>
  )
}

export default DraftsPage